(function (angular) {
	angular.module('bizPartEngage').directive('bizAdminBar', bizAdminBar);
	angular.module('bizPartEngage').service('bizAdminBarService', bizAdminBarService);

	bizAdminBar.$inject = [];
	bizAdminBarService.$inject = ['$http'];

	function bizAdminBar() {
		return {
			restrict: 'E',
			templateUrl: siteRootPath + 'FrontEnd/Core/Directives/Views/AdminBar.html',
			controllerAs: 'vm',
			controller: bizAdminBarController,
			bindToController: true,
			scope: {
				simulating: '=',
				isAllowedToSimulate: '=?',
			},
		};
	}

	bizAdminBarController.$inject = [
		'$rootScope',
		'bizCoreService',
		'$window',
		'$filter',
		'$mdDialog',
		'bizAdminBarService',
		'bizUser',
		'$transitions',
		'$state',
		'$stateParams',
		'$q',
	];

	function bizAdminBarController(
		$rootScope,
		bizCoreService,
		$window,
		$filter,
		$mdDialog,
		bizAdminBarService,
		bizUser,
		$transitions,
		$state,
		$stateParams,
		$q
	) {
		var vm = this;

		vm.Init = Init;
		vm.GetCultures = GetCultures;
		vm.ChangeCulture = ChangeCulture;
		vm.CancelSimulation = CancelSimulation;
		vm.ShowSimulateUser = ShowSimulateUser;
		vm.GetAdminUrl = GetAdminUrl;
		vm.ShowAdminButton = ShowAdminButton;
		vm.SetEditButton = SetEditButton;
		vm.GotoAdminEdit = GotoAdminEdit;

		vm.SimulatingDate = BizPartCoreHelpers.getSimulatedDate();

		function ShowAdminButton() {
			//if (!vm.simulating || (vm.simulating && bizUser.HasModuleAccess('DASHBOARD', 20)))
			return true;

			//return false;
		}

		function GetAdminUrl() {
			return bizAdminBarService.AdminUrl || $filter('siteroot')('Admin');
		}

		function CancelSimulation() {
			bizAdminBarService.CancelSimulation().then(CancelSimulationCallback);

			function CancelSimulationCallback(response) {
				var simulation = response.data;
				// Preserve the persistent auth cookie restored by the backend.
				setBizPartAuthToken(simulation.SimulatedByUserToken, simulation.SimulatedByUserId);
				deleteSessionStorage('SimulateDate');
				$window.location.href = $filter('siteroot')('/');
			}
		}

		function ShowSimulateUser() {
			$mdDialog.show({
				templateUrl: 'simulate-user',
				controller: simulateUserDialogController,
				controllerAs: 'vm',
				bindToController: true,
			});

			simulateUserDialogController.$inject = ['$mdDialog', '$scope'];

			function simulateUserDialogController($mdDialog, $scope) {
				var vm = this;

				vm.Users = [];
				vm.SearchTerm = '';
				vm.PageIndex = 0;
				vm.PageLength = 20;
				vm.IncludeInactive = false;
				vm.RoleId = -1;

				vm.Close = Close;
				vm.SearchUsers = SearchUsers;
				vm.SimulateUser = SimulateUser;
				vm.SearchMoreUsers = SearchMoreUsers;

				function SearchUsers(pageIndex) {
					vm.PageIndex = pageIndex || 0;
					vm.GettingUsers = true;
					bizAdminBarService
						.SearchUsers(vm.SearchTerm, vm.PageIndex, vm.PageLength, vm.IncludeInactive, vm.RoleId)
						.then(SearchUsersCallback);

					function SearchUsersCallback(response) {
						vm.UserData = response.data;

						if (vm.PageIndex == 0) vm.Users = vm.UserData.CurrentPageEntries;
						else vm.Users = vm.Users.concat(vm.UserData.CurrentPageEntries);

						vm.GettingUsers = false;
					}
				}

				function SearchMoreUsers() {
					vm.SearchUsers(vm.PageIndex + 1);
				}

				function SimulateUser(user) {
					vm.PreparingSimulation = true;
					bizAdminBarService.SimulateUser(user.Id, vm.Date).then(SimulateUserCallback);

					function SimulateUserCallback(response) {
						var userSession = response.data;
						if (!userSession) return;

						setBizPartAuthToken(userSession.Token, userSession.UserId);
						if (vm.Date) {
							setSessionStorage('SimulateDate', moment(vm.Date).format('YYYY-MM-DD HH:mm'));
						}
						$window.location.href = $filter('siteroot')('/');
					}
				}

				function Close() {
					$mdDialog.hide();
				}

				function GetRoles() {
					bizCoreService.Admin.GetAllRoles(false).then(GetAllRolesCallback);

					function GetAllRolesCallback(response) {
						vm.Roles = response.data;
					}
				}

				$scope.$watch('vm.SelectedRole', function (newValue, oldValue) {
					if (newValue != oldValue) {
						vm.RoleId = newValue?.Id ?? -1;
						vm.SearchUsers(0);
					}
				});

				GetRoles();
				vm.SearchUsers();
			}
		}

		function ChangeCulture(culture) {
			$window.location.href = $filter('siteroot')('/?lang=' + culture.CultureCode.substring(0, 2));
		}

		function GetCultures() {
			bizCoreService.GetCultures().then(GetCulturesCallback);

			function GetCulturesCallback(response) {
				vm.Cultures = response.data;
				vm.CurrentCulture = vm.Cultures.GetItemByValue('Id', ~~currentCultureId);
			}
		}

		function SetEditButton() {
			console.log('state', $state.current);
			let showBtn = false;
			const stateName = $state.current.name;
			if (vm.AdminPageMap.has(stateName)) {
				const adminInfo = vm.AdminPageMap.get(stateName);
				if (!adminInfo.accessTypeKey || $rootScope.HasWriteOrHigherAccess(adminInfo.accessTypeKey)) {
					showBtn = true;
				} else {
					console.log('no access');
				}
			}
			vm.ShowEditButton = showBtn;
		}

		function GotoAdminEdit() {
			const stateName = $state.current.name;

			if (vm.AdminPageMap.has(stateName)) {
				const adminInfo = vm.AdminPageMap.get(stateName);
				if (adminInfo.dynamic) {
					adminInfo.getFinalUrl(adminInfo.url).then((url) => {
						$window.location = siteRootPath + url;
					});
				} else {
					$window.location = siteRootPath + adminInfo.url;
				}
			}
		}

		function Init() {
			vm.GetCultures();

			vm.LimitedAccessModeUnit = limitedAccessModeUnit; //from global

			const populateId = (url, moduleType, urlRewrite) => {
				const deferred = $q.defer();
				bizAdminBarService.GetIdByUrlRewrite(moduleType, urlRewrite).then((response) => {
					const data = BizPartCoreHelpers.getResponseValue(response);

					if (moduleType === 'CMS' && data && data.Id > 0) {
						const pageData = BizPartCoreHelpers.getResponseValue(response);
						const containerVersion = pageData?.Container?.Version || pageData?.Container?.version;

						if (containerVersion > 1 ?? false) url = url.replace('/admin/modules/cms', '/admin/ncmsadmin');

						if (pageData?.GenericCategoryIds && pageData.GenericCategoryIds.length > 0)
							url = url.replace('##id##', pageData.GenericCategoryIds[0] + '/##id##');

						const fUrl = url.replace('##id##', pageData.Id);
						deferred.resolve(fUrl);
					} else if (~~data > 0) {
						const fUrl = url.replace('##id##', data);
						deferred.resolve(fUrl);
					} else {
						deferred.reject('Id not found');
					}
				});
				return deferred.promise;
			};

			const getUrlWithReplacedStateParamId = (url) => {
				const deferred = $q.defer();
				const finalUrl = url.replace('##id##', $stateParams.id);
				deferred.resolve(finalUrl);
				return deferred.promise;
			};

			vm.AdminPageMap = new Map([
				[
					'base.modules.blog',
					{
						url: 'Admin#/admin/modules/blog/index',
						accessTypeKey: 'BLOG',
					},
				],
				[
					'base.modules.blogtitle',
					{
						url: 'Admin#/admin/modules/blog/edit/##id##',
						accessTypeKey: 'BLOG',
						dynamic: true,
						getFinalUrl: (url) => populateId(url, 'Blog', $stateParams.title),
					},
				],
				[
					'base.modules.cms',
					{
						url: 'Admin#/admin/modules/cms/edit/##id##',
						accessTypeKey: 'CMS',
						dynamic: true,
						getFinalUrl: (url) => populateId(url, 'CMS', $stateParams.id),
					},
				],
				[
					'base.modules.media',
					{
						url: 'Admin#/admin/modules/mediabank/general',
						accessTypeKey: 'MEDIABANK',
					},
				],
				[
					'base.modules.mediafile',
					{
						url: 'Admin#/admin/modules/mediabank/view/##id##',
						accessTypeKey: 'MEDIABANK',
						dynamic: true,
						getFinalUrl: (url) => populateId(url, 'MediabankFile', $stateParams.id),
					},
				],
				[
					'base.modules.event',
					{
						url: 'Admin#/admin/modules/events/edit/##id##',
						accessTypeKey: 'EVENT',
						dynamic: true,
						getFinalUrl: (url) => getUrlWithReplacedStateParamId(url),
					},
				],
				[
					'base.modules.journey',
					{
						url: 'Admin#/admin/journey',
						accessTypeKey: 'JOURNEY',
					},
				],
			]);

			if (
				$rootScope.MiniSettings['Startpage']['DisableLoadData'] === false &&
				$rootScope.GetPreloadedPortalSetting('StartPageId') === -1
			) {
				vm.AdminPageMap.set('base.home', {
					url: 'Admin#/admin/portal/startpage',
					accessTypeKey: 'PORTAL',
				});
			}

			vm.SetEditButton();

			$transitions.onSuccess({}, ($transition) => {
				vm.SetEditButton();
			});
		}

		$rootScope.Initialized.then(vm.Init);
	}

	function bizAdminBarService($http) {
		return {
			SearchUsers: SearchUsers,
			SimulateUser: SimulateUser,
			CancelSimulation: CancelSimulation,
			GetIdByUrlRewrite: GetIdByUrlRewrite,
		};

		function SimulateUser(userId, date) {
			return $http.post(siteRootPath + 'api/UserAdmin/SimulateUser', {
				UserId: userId,
				Date: date,
			});
		}

		function CancelSimulation() {
			return $http.post(siteRootPath + 'api/User/CancelUserSimulation');
		}

		function SearchUsers(searchTerm, pageIndex, pageLength, includeInactive, roleId) {
			return $http.post(siteRootPath + 'api/UserAdmin/SearchUsersPaged', {
				searchTerm: searchTerm,
				pageIndex: pageIndex,
				pageLength: pageLength,
				includeInactive: includeInactive,
				roleId: roleId,
			});
		}

		function GetIdByUrlRewrite(objectType, urlRewrite) {
			var url = siteRootPath + 'api/Engage/GetIdByUrlRewrite';
			if (objectType === 'CMS') {
				url = siteRootPath + 'api/cmsuser/GetCMSPage'; //GetCMSPageId
			}

			return $http.get(url, {
				params: {
					objectType,
					urlRewrite,
				},
				headers: {
					IgnoreLoader: true,
				},
			});
		}
	}
})(window.angular);
